// Start FontAwesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { faBackward, faForward, faChevronDown, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Vue from "vue";

library.add([faBackward, faForward, faChevronDown,faChevronRight]);
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.config.productionTip = false;
// End FontAwesome
